export const EXAM_LABELS = {
  JEE_MAIN: "JEE Main",
  JEE_ADVANCED: "JEE Advanced",
  NEET: "NEET",
};

export const SUBJECT_LABELS = {
  PHYSICS: "Physics",
  CHEMISTRY: "Chemistry",
  MATHEMATICS: "Mathematics",
  BOTANY: "Botany",
  ZOOLOGY: "Zoology",
};

export const DIFFICULTY_LABELS = { EASY: "Easy", MEDIUM: "Medium", HARD: "Hard" };

export const examsForPref = (pref) => (pref === "NEET" ? ["NEET"] : ["JEE_MAIN", "JEE_ADVANCED"]);
export const subjectsForPref = (pref) =>
  pref === "NEET" ? ["PHYSICS", "CHEMISTRY", "BOTANY", "ZOOLOGY"] : ["PHYSICS", "CHEMISTRY", "MATHEMATICS"];

export const difficultyClass = (d) =>
  ({
    EASY: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 border-green-200 dark:border-green-900/50",
    MEDIUM:
      "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400 border-amber-200 dark:border-amber-900/50",
    HARD: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 border-red-200 dark:border-red-900/50",
  }[d] || "");

export const subjectAccent = (s) =>
  ({
    PHYSICS: "text-blue-500",
    CHEMISTRY: "text-emerald-500",
    MATHEMATICS: "text-violet-500",
    BOTANY: "text-green-500",
    ZOOLOGY: "text-rose-500",
  }[s] || "text-muted-foreground");

export const fmtTime = (secs) => {
  const s = Math.max(0, Math.floor(secs));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
};

export const arraysEqualSet = (a, b) => {
  const A = [...a].sort();
  const B = [...b].sort();
  return A.length === B.length && A.every((v, i) => v === B[i]);
};
